// extracted by mini-css-extract-plugin
module.exports = {"select":"_1A1LoVeQk_8WkfoKrc8T1j"};